const duration = /^[0-9]{1,7}$/;
const visibility = {
  visibility_state: new Set(['visible', 'hidden']),
  visibility_observed_hidden: new Set(['true', 'false']),
  visibility_observation_start_ms: duration,
};

export const STARTUP_CHECKPOINT_PROPS = {
  duration_ms: duration,
  dns_ms: duration,
  connect_ms: duration,
  request_ms: duration,
  response_ms: duration,
  dom_interactive_ms: duration,
  ...visibility,
};

export const STARTUP_PHASE_PROPS = {
  phase: new Set(['initial_map', 'account', 'application']),
  outcome: new Set(['completed', 'failed']),
  duration_ms: duration,
  elapsed_ms: duration,
  ...visibility,
};

export function journeyDiagnosticEventProps<const Common extends Record<string, import('./analytics-types.js').PropRule>>(common: Common) {
  return {
    save_clicked: common,
    save_completed: common,
    save_prompted_signin: common,
    save_dialog_opened: common,
    save_dialog_canceled: common,
    save_dialog_submitted: common,
    save_dialog_failed: common,
    startup_phase_performance: { ...common, ...STARTUP_PHASE_PROPS },
  };
}
